import React, { useCallback, useEffect, useState } from 'react';
import { DevModeContext } from './context';
import { isMobileTerminal } from '../../utils/isMobileTerminal';

const DevModeProvider = ({ children }) => {
    const [mode, setMode] = useState('hr'); 
    const [bootstrapped, setBootstrapped] = useState(false);

    useEffect(() => {
        
        if (isMobileTerminal()) {
            setMode('mobile-msg');
        } else {
            
            
            setMode('hr');
        }
        setBootstrapped(true);
    }, []);

    const enterDevMode = useCallback(() => {
        setMode('dev');
        
    }, []);

    const exitDevMode = useCallback(() => {
        if (isMobileTerminal()) return; 
        setMode('hr');
        
    }, []);

    if (!bootstrapped) return null;

    return (
        <DevModeContext.Provider value={{ mode, enterDevMode, exitDevMode }}>
            {children}
        </DevModeContext.Provider>
    );
};

export default DevModeProvider;